interface CopilotSendBlockers {
  noCredits: boolean;
  hasPendingActions?: boolean;
  approvalSending?: boolean;
  /** The server turn is still running after the local run ended (a stopped answer settling). */
  awaitingStoppedTurn?: boolean;
}

// While the server turn is running it answers any new message with a 409 that
// carries no restore reason, which the runtime surfaces as nothing at all.
export function isCopilotSendDisabled({
  noCredits,
  hasPendingActions = false,
  approvalSending = false,
  awaitingStoppedTurn = false,
}: CopilotSendBlockers): boolean {
  return noCredits || hasPendingActions || approvalSending || awaitingStoppedTurn;
}

export function isAwaitingStoppedCopilotTurn(
  localRunActive: boolean,
  serverTurnStatus: string | null | undefined,
): boolean {
  return !localRunActive && serverTurnStatus === "running";
}

export function preventUnavailableCopilotSubmit(
  event: { preventDefault: () => void },
  sendDisabled: boolean,
): void {
  if (sendDisabled) event.preventDefault();
}
